export function metricSorter(a: number | null, b: number | null) {
    if (a === null && b === null) return 0;
    if (a === null) return -1;
    if (b === null) return 1;

    return a - b;
}
